import React from "react";
import { useTranslation } from "react-i18next";
import "./JoinChicButton.css";

function JoinChicButton() {
  const { t } = useTranslation();
  return (
    <div className="join-chic-button-container">
      <a
        className="join-chic-button"
        href="https://chat.whatsapp.com/LnwzyM4N6QL35xcYQNYTen"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("join_chic_button")}
      </a>
    </div>
  );
}

export default JoinChicButton;
